module.exports = __webpack_public_path__ + "../public/img/whiskey.0fc4fdee.png";